export function renderJunctionTableGeneratedValueTemplate({
  toCamelCase,
  junctionPascal,
  schemaIdCol,
  schemaTableRef,
  relationIdCol,
  relationIdType,
  relationTableRef
}: {
  toCamelCase: string
  junctionPascal: string
  schemaIdCol: string
  schemaTableRef: string
  relationIdCol: string
  relationIdType: string
  relationTableRef: string
}): string {
  return `export const ${toCamelCase} = pgTable(
  '${junctionPascal}',
  {
    ${schemaIdCol}: uuid().notNull().references(() => ${schemaTableRef}.id, { onDelete: 'cascade' }),
    ${relationIdCol}: ${relationIdType}().notNull().references(() => ${relationTableRef}.id, { onDelete: 'cascade' })
  },
  (table) => [primaryKey({ columns: [table.${schemaIdCol}, table.${relationIdCol}] })]
)
`
}
